import script from "./GenerateSnippetTagDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateSnippetTagDialog.vue?vue&type=script&setup=true&lang=js"

import "./GenerateSnippetTagDialog.vue?vue&type=style&index=0&id=5cb9156e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb9156e"]])

export default __exports__